type ObjectWithPromiseProperties<T extends object> = {
  [K in keyof T]: Promise<T[K]> | T[K]
}

export default async function allProperties<T extends object>(object: ObjectWithPromiseProperties<T>): Promise<T> {
  const result = { ...object }

  const promises = []

  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const value = object[key]
      if (value instanceof Promise) {
        promises.push(value.then(resultValue => (result[key] = resultValue)))
      }
    }
  }

  await Promise.all(promises)
  return result as T
}
